'use strict';
import { tns } from "tiny-slider/src/tiny-slider"

class SnipetWithImage {

	constructor($target) {

		//Private properties
		$target;

		let name = "HELLO";

		function init(){
			initSLider()
			addClasses()
		}

		function initSLider(){
			var slider = tns({
				container: $target.find('.block_snipet_with_image__content_container')[0],
				items: 1,
				slideBy: 'page',
				autoplay: false,
				controls:false,
				nav: true,
				navPosition: "bottom",
				loop: false,
				edgePadding: 20,
				gutter: 20,

				responsive: {
					768: {
					  items: 2,
					}
				}
			  });
		}

		function addClasses(){
			var tnsOuter = $target.find('.tns-outer');
			var tnsInner = $target.find('.tns-inner');
			var tnsSlider = $target.find('.tns-slider');
			var tnsOvh = $target.find('.tns-ovh');
			var tnsitem = $target.find('.tns-item');

			tnsOuter.addClass('block_snipet_with_image__tns-outer');
			tnsInner.addClass('block_snipet_with_image__tns-inner');
			tnsSlider.addClass('block_snipet_with_image__tns-slider');
			tnsOvh.addClass('block_snipet_with_image__tns-ovh');
			tnsitem.addClass('block_snipet_with_image__tns-item');

			$(tnsitem).css('padding', 'none');

		}


		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default SnipetWithImage;